export default {
  singularNotClassified: 'Unclassified',
  pluralNotClassified: 'Unclassified',
  showNotClassified: 'Show unclassified',
  showClassified: 'Hide unclassified',
};
